import { MY_TEAMS_ADVISOR } from '@zet/constants'
import ENDPOINTS, { APP_NAME } from '@zet/end-points'
import { zetApi } from '@zet/network'
import storageUtil from '@zet/utils/storage'

import {
  ICreditReport,
  INotifications,
  IUserContext,
  IZetUserInfo,
} from './types'

export const getUserContext = async () => {
  const { data } = await zetApi.request<IUserContext>({
    url: ENDPOINTS[APP_NAME].getUserContext.endpoint,
    method: ENDPOINTS[APP_NAME].getUserContext.method,
  })
  storageUtil.saveObject('userId', data?.data.id)
  return APP_NAME === MY_TEAMS_ADVISOR
    ? formatDataForMyTeams(data)
    : formatDataForZetApp(data)
}

const formatDataForMyTeams = (data: IUserContext) => {
  return { ...data?.data, fullName: data?.data?.name }
}

const formatDataForZetApp = (data: IUserContext) => {
  let modifiedData = { ...data?.data }
  if (typeof data.data?.occupation !== 'object') {
    modifiedData = {
      ...modifiedData,
      occupation: {
        key: modifiedData?.occupation,
        value: data.data?.occupation,
      },
    }
  }
  if (typeof data.data?.workExperience !== 'object') {
    modifiedData = {
      ...modifiedData,
      workExperience: { key: modifiedData?.workExperience },
    }
  }
  if (data.data?.paymentDetailsAdded) {
    modifiedData = {
      ...modifiedData,
      isDefaultPaymentEdited: modifiedData?.paymentDetailsAdded,
    }
  }
  return {
    ...modifiedData,
    phoneNumber: modifiedData?.phoneNumber?.substring(2),
  }
}

export async function getCreditReport() {
  const { data } = await zetApi.request<ICreditReport>({
    url: ENDPOINTS[APP_NAME].getCreditReport.endpoint,
    method: ENDPOINTS[APP_NAME].getCreditReport.method,
  })
  const responseObject = {
    creditScore: data?.data?.response?.credit_score,
    badAccounts: data?.data?.response?.bad_accounts,
    creditCards: data?.data?.response?.credit_cards,
    personalLoans: data?.data?.response?.personal_loans,
    activeAccounts: data?.data?.response?.active_accounts,
    delayedPayments: data?.data?.response?.delayed_payments,
    bureau: data?.data?.response?.bureau,
    fullName: data?.data?.fullName,
    bureauReportFetchedAt: data?.data?.bureauReportFetchedAt,
  }
  return responseObject
}

export async function getCreditScoreUrl() {
  const { data } = await zetApi.request<IUserContext>({
    url: ENDPOINTS[APP_NAME].getCreditScoreUrl.endpoint,
    method: ENDPOINTS[APP_NAME].getCreditScoreUrl.method,
  })
  return data
}

export async function getUserSummary() {
  const { data } = await zetApi.get<IZetUserInfo>('user/summary')
  return data?.data
}

export async function setNotificationToken(deviceToken: string) {
  const { data } = await zetApi.post<INotifications>('user/save/deviceToken', {
    deviceToken,
  })
  return data.data
}

export async function setCustomerNotificationToken({
  fcmToken,
  customerId,
}: {
  fcmToken: string
  customerId: number
}) {
  try {
    if (customerId) {
      const { data } = await zetApi.post<INotifications>(
        'public/customer/saveFcmTokenForCustomer',
        {
          fcmToken,
          customerId,
        }
      )
      return data?.data
    } else {
      throw new Error('Customer ID not found')
    }
  } catch (error) {
    console.warn(error)
  }
}
